import { Navigate } from "react-router-dom";

/**
 * DashboardIndex - Redirects to Wallet as the master dashboard page
 * 
 * Overview was removed as it duplicated Wallet functionality.
 * Wallet is now the primary dashboard experience.
 */
export function DashboardIndex() {
  return <Navigate to="/dashboard/wallet" replace />;
}

